import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { addToCart } from "../../../../_actions/cart.actions";
import { cartConstants } from "../../../../_constants";
import { isCourseInCart, buildCourseDetailsURI } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";

const AddToCartButton = ({
  post,
  loggedIn,
  cartItems,
  currentItem,
  history,
  currentState,
  geoLocation,
  error,
  bundle,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const getCoupon = (cartItems) => {
    return cartItems.find((item) => item.PromoApplied)?.PromoCodeApplied;
  };

  const handleCartClick = (
    event,
    loggedIn,
    history,
    course,
    cartItems,
    geoLocation
  ) => {
    event.preventDefault();
    return !loggedIn
      ? history.push("/login")
      : dispatch(
          addToCart(course.ID, getCoupon(cartItems), geoLocation, bundle)
        );
  };

  const SuccessResponse = ({ isAdded, error }) => {
    const [isActive, setActive] = useState(true);
    useEffect(() => {
      const timeoutID = setTimeout(() => {
        setActive(false);
        dispatch({ type: cartConstants.ADD_TO_CART_RESET });
      }, 2000);
      return () => clearTimeout(timeoutID);
    }, []);
    return isActive ? (
      <a href="javascript(void);" className="disabled">
        <span className={`add-to-cart ${isAdded ? "success" : "failed"}`}>
          {isAdded ? "Item Added to Cart" : error}
        </span>
      </a>
    ) : isAdded ? (
      <GoToCart />
    ) : (
      <AddToCart />
    );
  };

  const renderCartButton = (
    loggedIn,
    cartItems,
    post,
    error,
    currentStatus
  ) => {
    switch (currentStatus) {
      case "processing":
        return (
          <a href="javascript(void);" className="disabled">
            <Loading />
          </a>
        );
      case "success":
        return <SuccessResponse isAdded={true} />;
      case "failed":
        return <SuccessResponse error={error} />;
      default:
        return isCourseInCart(
          loggedIn,
          cartItems,
          post,
          bundle ? true : false
        ) ? (
          <GoToCart />
        ) : (
          <>{!post?.isPurchased ? <AddToCart /> : <PurchasedCourse />}</>
        );
    }
  };

  const AddToCart = () => {
    return (
      <>
        <a
          href="javascript(void);"
          onClick={(event) =>
            handleCartClick(
              event,
              loggedIn,
              history,
              post,
              cartItems,
              geoLocation
            )
          }
        >
          <span className="add-to-cart">{t("Enroll")}</span>
        </a>
      </>
    );
  };

  const GoToCart = () => {
    return <Link to="/dashboard/cart">{t("goToCart")}</Link>;
  };

  const PurchasedCourse = () => {
    return (
      <Link
        to={{
          pathname: buildCourseDetailsURI(
            post.Category,
            post.CourseName,
            post.ID
          ),
        }}
      >
        <span>ALREADY ENROLLED</span>
      </Link>
    );
  };

  return (
    <>
      {currentItem === post.ID
        ? renderCartButton(loggedIn, cartItems, post, error, currentState)
        : renderCartButton(loggedIn, cartItems, post, error)}
    </>
  );
};

function mapStateToProps(state) {
  const { loggedIn, geoLocation } = state.authentication;
  const { cartItems, currentItem, currentState, error } = state.cart;
  return {
    geoLocation,
    loggedIn,
    cartItems,
    currentItem,
    currentState,
    error,
  };
}

const CartButton = connect(mapStateToProps)(AddToCartButton);
export default withRouter(CartButton);
